/**
 * EventStartDate
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import FormattedDate from '../FormattedDate';

// Selectors
import { makeSelectEventValue } from '../../services/events/selectors';

interface Props {
    startDate?: string;
    prefix?: string;
}

export class EventStartDate extends React.PureComponent<Props> {
    render() {
        const { startDate, prefix } = this.props;
        if (!startDate) return null;
        return (
            <React.Fragment>
                {prefix}
                <FormattedDate value={startDate} format="MMM D" />
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    startDate: makeSelectEventValue('startDate')
});

export default connect(mapStateToProps)(EventStartDate);
